export const NexusRoutes = {
  ContactUs: '/contact_form/',
  Properties: '/properties/all/',
};
